import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { fetchUserBootstrap } from "@/lib/user-bootstrap";

export type UserRoleType = "user" | "venue_owner" | "admin" | null;

export const useUserRole = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isVenueOwner, setIsVenueOwner] = useState(false);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    let active = true;
    if (!user) {
      setIsAdmin(false);
      setIsVenueOwner(false);
      setRoleLoading(false);
      return;
    }

    setRoleLoading(true);
    fetchUserBootstrap(user.id).then((bootstrap) => {
      if (!active) return;
      setIsAdmin(bootstrap.roles.includes("admin"));
      setIsVenueOwner(bootstrap.roles.includes("venue_owner"));
      setRoleLoading(false);
    });

    return () => {
      active = false;
    };
  }, [user]);

  const isBusinessUser = isAdmin || isVenueOwner;

  return { isAdmin, isVenueOwner, isBusinessUser, roleLoading };
};
